import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-password-field',
  templateUrl: './password-field.component.html',
  styleUrls: ['./password-field.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class PasswordFieldComponent implements OnInit, AfterViewInit {
  constructor(private ToastService: ToastService) {}

  @ViewChild('passwordField') passwordField!: ElementRef<HTMLInputElement>;

  @Input() passwordFormControl!: FormControl<string>;

  toggleRevealPassword() {
    const { nativeElement } = this.passwordField;
    const { type } = nativeElement;

    if (type === 'password') {
      Object.assign(nativeElement, { type: 'text' });
    } else {
      Object.assign(nativeElement, { type: 'password' });
    }
  }

  ngAfterViewInit(): void {
    if (!this.passwordField) {
      throw this.ToastService.addErrorToast(
        'Error',
        'There was an error retrieving the password field.',
        { returnError: true }
      );
    }
  }

  ngOnInit(): void {
    if (!this.passwordFormControl) {
      throw this.ToastService.addErrorToast(
        'Error',
        'Missing Password Form Control.',
        { returnError: true }
      );
    }
  }
}
